import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push, goBack } from 'react-router-redux';
import seo from 'shared/lib/seo';
import compact from 'lodash/compact';
import omit from 'lodash/omit';
import TopNavBar from '../../components/TopNavBar';
import api from '../../api';
import withSubapp from 'shared/lib/apps/RentersApp/hoc';
import withGlobals from '../../withGlobals';
import { showMenu, hideMenu, hideToast } from '../../store/actions';

class Renters extends Component {
  componentDidMount() {
    seo.setProps({
      title: 'Renters Insurance | Sure',
      description:
        'Get Renters Insurance through Sure to protect your clothes, furniture, and yourself. Plans as low as $11/month.',
      url: 'https://www.sureapp.com/renters-insurance',
    });
  }

  render() {
    return (
      <div className="Renters">
        {compact(this.props.location.pathname.split('/')).length > 1 && (
          <TopNavBar
            isLoggedIn={this.props.isLoggedIn}
            userFullName={this.props.userFullName}
            isMenuOpen={this.props.isMenuOpen}
            activeLink={this.props.location.pathname}
            onHideMenu={this.props.hideMenu}
            onShowMenu={this.props.showMenu}
          />
        )}
        {React.cloneElement(this.props.children, omit(this.props, 'children'))}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    account: state.account,
    isLoggedIn: !!state.authToken,
    isMenuOpen: state.isMenuOpen,
    isPurchaseInProgress: state.isPurchaseInProgress,
    toast: state.toast,
    userFullName: `${state.account.firstName} ${state.account.lastName}`,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    ...bindActionCreators(
      {
        hideMenu,
        hideToast,
        goBack,
        showMenu,
        navTo: pathname =>
          push({
            pathname,
            query: ownProps.location.query,
          }),
      },
      dispatch
    ),
  };
};

const enhance = compose(
  withRouter,
  withGlobals({
    analyticsPrefix: 'Renters',
  }),
  withSubapp(api),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(Renters);
